import { render, staticRenderFns } from "./ChatSuporte.vue?vue&type=template&id=b0a816ac&scoped=true&"
import script from "./ChatSuporte.vue?vue&type=script&lang=js&"
export * from "./ChatSuporte.vue?vue&type=script&lang=js&"
import style0 from "./ChatSuporte.vue?vue&type=style&index=0&id=b0a816ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a816ac",
  null
  
)

export default component.exports